{
	"type": "line",
	"minzoom": 8,
	"layout": {
		"line-sort-key": [
			"match",
			["get", "veh_str_rating_smoothed"],
			"1",
			5,
			"2",
			4,
			"3",
			3,
			"4",
			2,
			"5",
			1,
			0
		]
	},
	"paint": {
		"line-width": 2.8,
		"line-color": [
			"match",
			["get", "veh_str_rating_smoothed"],
			1,
			"#000000",
			2,
			"#e21736",
			3,
			"#f78f1e",
			4,
			"#ffed00",
			5,
			"#7ddb63",
			"#ddd"
		]
	},
	"filter": ["all", ["has", "veh_str_rating_smoothed"]]
}
